import {
  PLAYER_LIVE_OPTIONS_SHOW_OPTIONS,
  PLAYER_LIVE_OPTIONS_HIDE_OPTIONS,
  PLAYER_MODALS_Z_INDEX_INCREASE,
  PLAYER_MODALS_Z_INDEX_DECREASE,
} from './constants';

import { EPG_CLEAR_CHANNEL_EVENT } from '../liveMenu/constants';
import { setMenuOptions } from '../liveMenu/liveMenu.actions';

export const showLiveOptionsMenu = () => dispatch => {
  dispatch({ type: EPG_CLEAR_CHANNEL_EVENT });
  dispatch(setMenuOptions('main'));
  dispatch({
    type: PLAYER_MODALS_Z_INDEX_INCREASE,
  });
  dispatch({
    type: PLAYER_LIVE_OPTIONS_SHOW_OPTIONS,
  });
};

export const showLiveRecordMenu = () => dispatch => {
  dispatch({ type: EPG_CLEAR_CHANNEL_EVENT });
  dispatch({
    type: PLAYER_MODALS_Z_INDEX_INCREASE,
  });
  dispatch({
    type: PLAYER_LIVE_OPTIONS_SHOW_OPTIONS,
  });
};

export const showSelectedEventMenu = () => dispatch => {
  dispatch(setMenuOptions('main'));
  dispatch({
    type: PLAYER_MODALS_Z_INDEX_INCREASE,
  });
  dispatch({
    type: PLAYER_LIVE_OPTIONS_SHOW_OPTIONS,
  });
};

export const hideLiveOptionsMenu = () => (dispatch, getState) => {
  const state = getState();
  if (state?.Player?.OptionButtons?.liveOptions?.isOpen) {
    dispatch({
      type: PLAYER_MODALS_Z_INDEX_DECREASE,
    });
    dispatch({
      type: PLAYER_LIVE_OPTIONS_HIDE_OPTIONS,
    });
  }
};
